import * as fieldActions from './fieldActions'

import { Card } from '@atd/rui-base.mui.card'
import { CARD_SX } from '../ravenV5Theme'
import { CardActions } from '@atd/rui-base.mui.card-actions'
import { CardHeader } from '@atd/rui-base.mui.card-header'

import { Button } from '@atd/rui-base.mui.button'
import DeleteButton from '../commonComponents/deleteDialogButton'
import EditIcon from '@mui/icons-material/Create'
import FieldEdit from './fieldedit'
import GrassIcon from '@mui/icons-material/Grass'
import PropTypes from 'prop-types'
import React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'

function mapStateToProps(state, ownProps) {
    return {}
}

function mapDispatchToProps(dispatch) {
    return {
        ...bindActionCreators(fieldActions, dispatch),
    }
}

// TODO fix actions details -- use class? (Class unused at this point)
class FieldCard extends React.Component {
    static propTypes = {
        data: PropTypes.object,
        disabled: PropTypes.bool,
    }

    static defaultProps = {
        data: {},
        disabled: false,
    }

    constructor(props) {
        super(props)
        this.state = {
            editDialogOpen: false,
        }
    }

    handleDelete = () => {
        this.props.deleteField(this.props.data.id)
    }

    handleEditRequest = () => {
        this.setState({ editDialogOpen: true })
    }

    handleCancel = () => {
        this.setState({
            editDialogOpen: false,
        })
    }
    handleSave = newData => {
        this.props.updateField({...newData})
        this.setState({
            editDialogOpen: false,
        })
    }

    render() {
        return (
            <Card
                key={this.props.data.id}
                name={this.props.data.id}
                className="gffCard"
                sx={CARD_SX}
            >
                <CardHeader
                    sx={{ alignItems: 'flex-start' }}
                    title={this.props.data.name}
                    titleTypographyProps={{ style: { fontSize: '15px', lineHeight: 1.2 } }}
                    subheader="Field"
                    avatar={<GrassIcon htmlColor="#BCBCBC"/>}
                />
                <CardActions className="gffCardActions">
                    <Button variant="text"
                        startIcon={<EditIcon />}
                        onClick={this.handleEditRequest}
                        disabled={this.props.disabled}
                        color="primary"
                        name="openFieldDialog"><span className="btnLabel">Details</span></Button>
                    <DeleteButton
                        itemType="field"
                        deleteFunction={this.handleDelete}
                        disabled={this.props.disabled}
                        primary={true}
                    />
                    {this.state.editDialogOpen &&
                        <FieldEdit
                            data={this.props.data}
                            onCancel={this.handleCancel}
                            onSubmit={this.handleSave}
                        />
                    }
                </CardActions>
            </Card>
        )
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(FieldCard)
